export const PublicationRow = ({ pub }) => (
  <li className="flex gap-4 py-5" style={{ borderBottom: "1px solid var(--border-default)", listStyle: "none" }}>
    <span className="shrink-0 font-medium" style={{ width: 64, color: "var(--navy-700)" }}>
      {pub.year}
    </span>
    <div>
      <p className="body-default font-medium m-0 mb-1" style={{ color: "var(--ink-900)" }}>
        {pub.title}
      </p>
      <p className="body-sm italic m-0 mb-1" style={{ color: "var(--navy-500)" }}>
        {pub.venue}
      </p>
      <p className="caption m-0">{pub.authors}</p>
    </div>
  </li>
);
